import { render } from "./Zone.vue?vue&type=template&id=20a9dffe&ts=true"
import script from "./Zone.vue?vue&type=script&lang=ts"
export * from "./Zone.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__